<template>
  <div class="flex items-center justify-center w-full h-full">
    <div class="page-loader">
      <Spinner message="" class="spinner" />
      <slot name="body">
        <div>{{ message }}</div>
      </slot>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner.vue";

export default {
  components: {
    Spinner
  },
  props: {
    message: {
      type: String,
      default: "Loading..."
    }
  }
};
</script>

<style lang="scss" scoped>
.page-loader {
  background: #fff;
  z-index: 7;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray);
  flex-direction: column;
  border-radius: 6px;
  box-shadow: 0 4px 10px 0px rgba(0, 0, 0, 0.15);
  font-size: 1rem;
  border: 1px solid #ced4da;
  padding: 20px;
  .spinner {
    font-size: 2rem;
    height: 0.9em;
    width: 1em;
    margin-bottom: 20px;
  }
}
</style>
